module.exports = __webpack_public_path__ + "static/img/Josh-AddoCarr.18c6664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-AddoCarr.jpg
// module id = BLuq
// module chunks = 0